import DesktopViewWrapper from "pages/DesktopViewWrapper/DesktopViewWrapper";
import { Redirect, Route } from "react-router-dom";
import { routeTable } from "routes/routeData";

export function DesktopRouterOutlet() {
  return (
    <>
      {routeTable.map((route, idx) => {
        const { desktopTitle, path, component: Component } = route;

        return (
          <Route exact key={`desktop-route-${idx}`} path={path}>
            <DesktopViewWrapper title={desktopTitle}>
              <Component />
            </DesktopViewWrapper>
          </Route>
        );
      })}

      {/* Redirect */}
      <Route exact path="/">
        <Redirect to="/active-requests"></Redirect>
      </Route>
    </>
  );
}
